import { render, staticRenderFns } from "./yunnan.vue?vue&type=template&id=7756465a&scoped=true"
import script from "./yunnan.vue?vue&type=script&lang=js"
export * from "./yunnan.vue?vue&type=script&lang=js"
import style0 from "./yunnan.vue?vue&type=style&index=0&id=7756465a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7756465a",
  null
  
)

export default component.exports